// ==============================================================================
// index - Root of React app.
// ==============================================================================

// ==============================================================================
// Imports
// ==============================================================================
import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App';
import '@fontsource/saira-condensed';
import '@fontsource/roboto-condensed';


// import registerServiceWorker from './registerServiceWorker';

// ==============================================================================

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(<App />);
// registerServiceWorker();
